import useDevice from 'hooks/useDeviceType';
import { ReactNode } from 'react';

export default function ContainerByDevice({
  children,
  className,
  href,
  dataPulseName,
  dataTestId,
  ...rest
}: {
  children: ReactNode | ReactNode[];
  className?: string;
  href?: string;
  dataPulseName?: string;
  dataTestId?: string;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}) {
  const { isMobile, isTablet } = useDevice();

  return isMobile || isTablet ? (
    <div
      className={className}
      data-pulse-clickable
      data-pulse-name={dataPulseName}
      data-testid={dataTestId}
      {...rest}
    >
      {children}
    </div>
  ) : (
    <a
      {...rest}
      href={href}
      className={className}
      data-pulse-name={dataPulseName}
      data-testid={dataTestId}
    >
      {children}
    </a>
  );
}
